import { render, staticRenderFns } from "./crkIndex.vue?vue&type=template&id=24e55510&scoped=true"
import script from "./crkIndex.vue?vue&type=script&lang=js"
export * from "./crkIndex.vue?vue&type=script&lang=js"
import style0 from "./crkIndex.vue?vue&type=style&index=0&id=24e55510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e55510",
  null
  
)

export default component.exports